/**
 * Convierte un valor monetario (string o number) a número
 * @param value - El valor a convertir (puede ser string o number)
 * @returns El valor como número
 */
export const parseMonetaryValue = (
  value: string | number | null | undefined
): number => {
  if (value === null || value === undefined) return 0;
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

/**
 * Formatea un número como moneda en pesos argentinos
 * @param amount - El monto a formatear (puede ser string o number)
 * @returns El monto formateado como moneda
 */
export const formatCurrency = (
  amount: string | number | null | undefined
): string => {
  const numericAmount = parseMonetaryValue(amount);
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);
};

/**
 * Formatea el tipo de cama para mostrar texto combinado
 * @param tipoCama - Array de tipos de cama
 * @returns Texto formateado del tipo de cama
 */
export const formatTipoCama = (tipoCama?: string[] | string | null): string => {
  // Normalizar a array
  let arr: string[] = [];
  if (Array.isArray(tipoCama)) {
    arr = tipoCama.filter(Boolean);
  } else if (typeof tipoCama === "string" && tipoCama.trim() !== "") {
    arr = [tipoCama];
  }

  if (arr.length === 0) {
    return "No especificado";
  }
  if (arr.length === 1) {
    return arr[0] === "doble" ? "Cama doble" : "Camas individuales";
  }
  if (arr.length === 2 && arr.includes("doble") && arr.includes("individual")) {
    return "Camas individuales y doble";
  }
  return arr.join(", ");
};
